$(function () {
    $('[data-tab]').on('click', function (event) {
        event.preventDefault();

        let $this = $(this);
        let tabItem = $this.data('tab');
        let tabFor = $this.data('tab-for');

        $(tabFor).find($('[data-tab]')).removeClass('active');
        $(tabFor).find($('.jsTabItem')).addClass('hide');

        $this.addClass('active');
        $(tabItem).removeClass('hide');
    });
});
